import React, { useState } from 'react'
import classNames from 'classnames'

import styles from './icon_cards.module.sass'

import BlockWrapper from './layout/block_wrapper'
import Image from './basic/image'
import ScrollAnimation from './layout/scroll_animation'
import Button from './basic/button'
import Link from './basic/link'

function IconCards(props) {
	const fields = props.fields
	const [items, setItems] = useState(fields.items.map(obj => ({ ...obj, buttonActive: false })))
	
	const handleMouseEvent = (index) => {
		setItems(
			items.map(
				(item, itemIndex) => itemIndex === index ? { ...item, buttonActive: true } : { ...item, buttonActive: false }
			)
		)
	}

	return <div>
		<ScrollAnimation styles={styles}>
			<BlockWrapper {...props} className={classNames(styles.icon_cards, styles[fields.style])}>
				<div className={styles.icon_cards_wrapper}>
					<div className={styles.content_wrapper}>
						<div className={styles.content} dangerouslySetInnerHTML={{__html: fields.content}}></div>
						{fields.button?.url && 
							<Button fields={{button: fields.button, button_style: fields.button_style, button_color: fields.button_color}}>{fields.button.title}</Button>
						}
						{fields.secondary_button?.button?.url && 
							<Button className={styles.secondary_button} fields={{button: fields.secondary_button.button, button_style: fields.secondary_button.button_style, button_color: fields.secondary_button.button_color}}>{fields.secondary_button.button.title}</Button>
						}
					</div>
					<div className={styles.cards_wrapper}>
						{items && items.map((item, i) => {
							return <div key={i} className={classNames(styles.card)} 
								onMouseEnter={() => handleMouseEvent(i)}
								onMouseLeave={() => handleMouseEvent()}
							>
								<Link href={item.button.url} target={item.button.target} className={styles.link}>
									{fields.style == 'style_2' && <div className={styles.banner}><p className={styles.banner_text}>{item?.banner_text}</p></div>}
									{item.icon.url && <Image className={styles.icon} {...item.icon} />}
									<h3 className={classNames(styles.heading, 'h4')}>{item.heading}</h3>
									<div className={styles.content} dangerouslySetInnerHTML={{__html: item.content}}></div>
									{item.button.url && 
										<Button className={styles.button} button_style='style_2' active={item.buttonActive}>{item.button.title}</Button>
									}
								</Link>
							</div>
						})}
					</div>
				</div>
			</BlockWrapper>
		</ScrollAnimation>
	</div>
}

export default IconCards